<template>
<div>
    <navbar></navbar>
    <div class="container">
        <nav class="bd-tabs">
            <div class="tabs">
                <ul>
                    <li v-bind:class="{'is-active': activeTab==1}" @click="setView(1)"><a>Benutzerdaten verwalten</a></li>
                    <li v-bind:class="{'is-active': activeTab==2}" @click="setView(2)"><a>Mailinglisten verwalten</a></li>
                    <li v-bind:class="{'is-active': activeTab==3}" @click="setView(3)"><a>Passwort ändern</a></li>
                    <li v-bind:class="{'is-active': activeTab==4}" @click="setView(4)"><a>E-Mail-Adresse ändern</a></li>
                </ul>
            </div>
        </nav>
        <br>
        <router-view/>
    </div>
</div>
</template>

<script>
import Navbar from '@/components/Navbar';
export default {
    components: {
        Navbar,
    },
    props: [
        'initTab'
    ],
    data() {
        return {
            activeTab: this.initTab,
        }
    },
    mounted: function() {
        switch (this.$route.name) {
            case 'AccountManagement-Profile':
                this.activeTab = 1;
                break;
            case 'AccountManagement-Mailinglists':
                this.activeTab = 2;
                break;
            case 'AccountManagement-Password':
                this.activeTab = 3;
                break;
            case 'AccountManagement-MailChange':
                this.activeTab = 4;
                break;
            default:
                this.setView(1);
                break;
        }
    },
    methods: {
        setView(activeTab) {
            this.activeTab = activeTab;
            switch (activeTab) {
                case 1:
                    this.$router.push({name: 'AccountManagement-Profile'});
                    break;
                case 2:
                    this.$router.push({name: 'AccountManagement-Mailinglists'});
                    break;
                case 3:
                    this.$router.push({name: 'AccountManagement-Password'});
                    break;
                case 4:
                    this.$router.push({name: 'AccountManagement-MailChange'});
                    break;
            }
        }
    }
}
</script>

<style>
.bd-tabs .tabs ul {
    flex-wrap: wrap;
    max-width: 100%;
}
.container {
    padding: 1rem
}
</style>
